import { experiment } from "@faire/web/common/settings/declarations/experiment";

/**
 * A/B test for consumer redirects exploration feature
 * When enabled, users who click "I'm just shopping for myself" will be redirected to the brand page
 */
export const FE_CONSUMER_REDIRECTS_250825 = experiment({
  name: "FE_CONSUMER_REDIRECTS_250825",
  identifier: "SessionToken",
  client: ["RETAILER", "VISITOR_WEB"],
  notifyAfter: "2025-11-25",
  defaultValue: false,
  productArea: "LOGGED_OUT_RETAILERS",
});
